import { VehicleAssignTableDataDto } from '@interfaces/models';
import { Typography, ColumnDef } from '@ui/components';
import { Checkbox } from '@ui/components';
import { TFunction } from 'i18next';

export const getVehiclesColumns = (t: TFunction): ColumnDef<VehicleAssignTableDataDto>[] => [
  {
    id: 'select',
    size: 40,
    maxSize: 40,
    header: ({ table }) => (
      <Checkbox
        onCheckedChange={(value) => table.toggleAllRowsSelected(!!value)}
        checked={table.getIsAllRowsSelected()}
      />
    ),
    cell: ({ row }) => (
      <Checkbox
        onCheckedChange={(value) => row.toggleSelected(!!value)}
        checked={row.getIsSelected()}
        className="ml-0.5"
      />
    ),
  },
  {
    accessorKey: 'name',
    maxSize: 300,
    header: () => t('EMPLOYEES.VEHICLES_ASSIGN_NAME'),
    cell: ({ row }) => (
      <Typography variant="labelMediumBook" element="span">
        {row.original.name}
      </Typography>
    ),
  },
  {
    accessorKey: 'registrationNumber',
    maxSize: 300,
    header: () => t('EMPLOYEES.VEHICLES_ASSIGN_REGISTRATION_NUMBER'),
    cell: ({ row }) => (
      <Typography variant="labelMediumBook" element="span">
        {row.original.registrationNumber}
      </Typography>
    ),
  },
];
